import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { RotatingLines } from "react-loader-spinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const EditableDateField = ({
  id,
  type,
  disabled = false,
  value,
  field,
  onSave,
  isSuccess,
  isFail,
  setFailStatus,
}) => {
  const [editedValue, setEditedValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setEditedValue(value);
  }, [value]);

  const handleSave = async (newValue) => {
    if (value !== newValue) {
      setIsLoading(true);
      try {
        if (
          (field === "date" && newValue !== "") ||
          (field === "shipTo" && newValue.length >= 2)
        ) {
          await onSave(id, field, newValue);
        }
      } catch (error) {
        setFailStatus({
          field,
          id: id,
        });
        setTimeout(() => {
          setFailStatus({});
        }, 1000);
        setEditedValue(value);
      } finally {
        setTimeout(() => {
          setFailStatus({});
        }, 1000);
        setTimeout(() => setIsLoading(false), 200);
      }
    }
  };

  const handleBlur = () => {
    if (field !== "date") {
      handleSave(editedValue);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setEditedValue(newValue);
    if (field === "date") {
      handleSave(newValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  const handleDateChange = async (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      setEditedValue(formattedDate);
      await handleSave(formattedDate);
    }
  };

  if (type === "date") {
    return (
      <div
        style={{
          position: "relative",
          display: "inline-block",
          width: "max-content",
        }}
      >
        <DatePicker
          selected={editedValue ? new Date(editedValue) : null}
          onChange={handleDateChange}
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          disabled={disabled || isLoading}
          className="form-control form-control-sm"
          wrapperClassName="w-100"
          popperPlacement="bottom-start"
          showYearDropdown
          showMonthDropdown
          dropdownMode="select"
          customInput={
            <Form.Control
              type="text"
              className="form-control form-control-sm"
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "4px",
                padding: "6.5px 8px",
                width: "100%",
                fontSize: "0.975rem",
                backgroundColor: disabled ? "white" : "#fff",
                cursor: disabled ? "not-allowed" : "pointer",
                borderColor:
                  isSuccess?.id === id && isSuccess?.field === field
                    ? "green"
                    : isFail?.id === id && isFail?.field === field
                    ? "red"
                    : "#dee2e6",
                boxShadow:
                  isSuccess?.id === id && isSuccess?.field === field
                    ? "0 0 5px green"
                    : isFail?.id === id && isFail?.field === field
                    ? "0 0 5px red"
                    : "none",
              }}
            />
          }
        />
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              pointerEvents: "none",
              zIndex: 10,
            }}
          >
            <RotatingLines
              strokeWidth="5"
              animationDuration="0.75"
              width="16"
              strokeColor="#b2b4b9"
              visible={true}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <Form.Control
        type={type}
        value={editedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="form-control form-control-sm"
        style={{
          border: "1px solid #dee2e6",
          borderRadius: "4px",
          padding: "4px 8px",
          width: "100%",
          backgroundColor: disabled && "white",
          borderColor:
            isSuccess?.id === id && isSuccess?.field === field
              ? "green"
              : isFail?.id === id && isFail?.field === field && "red",
          boxShadow:
            isSuccess?.id === id && isSuccess?.field === field
              ? "0 0 5px green"
              : isFail?.id === id && isFail?.field === field && "0 0 5px red",
        }}
        disabled={isLoading || disabled}
      />
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        >
          <RotatingLines
            strokeWidth="5"
            animationDuration="0.75"
            width="20"
            strokeColor="#b2b4b9"
            color="#b2b4b9"
            visible={true}
          />
        </div>
      )}
    </div>
  );
};

export default EditableDateField;
